import { baseApi, ApiError } from './api-client/base';
import { authService } from './api-client/auth';
import { lawsuitService } from './api-client/lawsuit';
import { financialService } from './api-client/financial';
import { officeService } from './api-client/office';
import { contactService } from './api-client/contact';
import { dashboardService } from './api-client/dashboard';
import { auditService } from './api-client/audit';
import { eventService } from './api-client/event';
import { timesheetService } from './api-client/timesheet';
import { billingService } from './api-client/billing';

export { ApiError };

/**
 * @deprecated Use domain-specific services directly (e.g., authService, lawsuitService)
 * This facade is kept for backward compatibility during the refactoring process.
 */
export const apiClient = {
  // Base methods
  request: baseApi.request.bind(baseApi),
  refreshToken: baseApi.refreshToken.bind(baseApi),

  // Domain services
  ...authService,
  ...lawsuitService,
  ...financialService,
  ...officeService,
  ...contactService,
  ...dashboardService,
  ...auditService,
  ...eventService,
  ...timesheetService,
  ...billingService,
};
